import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-vorlagen-mit-abteilungen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentVorlagenMitAbteilungenEffects {

    IncidentVorlagenMitAbteilungen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_VORLAGEN_MIT_ABTEILUNGEN),
        mergeMap((x: ac.GetIncidentVorlagenMitAbteilungenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentVorlagenMitAbteilungen().pipe(
                map((result: any) => {
                    return new ac.GetIncidentVorlagenMitAbteilungenErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentVorlagenMitAbteilungenFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
